export enum MeetingStatus {
   'Not Started',
   'In Progress',
   'Completed'
}
